"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteEntities = exports.storeNormalizedEntities = exports.getOddsStatistic = exports.getEventLiveOfTheDay = exports.getEventMatchOfTheDay = exports.getMarketTemplates = exports.getFreebets = exports.endMatch = exports.deleteMatchId = exports.makeSearchMatchesFn = exports.makeGetMatchesByFilters = exports.makeGetMatchesByEventIds = exports.makeGetMissingMatches = exports.refetchMatch = exports.getMatch = exports.getTournamentBySlug = exports.getMatchBySlug = exports.makeGetBets = exports.makeGetMatch = exports.getSports = void 0;
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
var lodash_1 = require("lodash");
var constants_1 = require("../constants");
var utils_1 = require("../utils");
var constants_2 = require("./constants");
var getSports = function (variables) {
    return {
        type: constants_2.GET_SPORTS_REQUEST,
        payload: {
            method: 'getSports',
            variables: variables,
        },
        meta: { isApiCall: true },
    };
};
exports.getSports = getSports;
function makeGetMatch(_a) {
    var type = _a.type, meta = _a.meta, _b = _a.defaultArgs, defaultArgs = _b === void 0 ? {} : _b;
    return function (variables, args) {
        if (args === void 0) { args = {}; }
        var propsToPick = [
            'sportEventsIds',
            'marketStatuses',
            'marketLimit',
        ];
        return {
            type: type,
            payload: {
                method: 'getMatchesByIds',
                variables: lodash_1.pick(variables, propsToPick),
                args: __assign(__assign({}, defaultArgs), args),
            },
            meta: __assign({ isApiCall: true }, meta),
        };
    };
}
exports.makeGetMatch = makeGetMatch;
var makeGetBets = function (_a) {
    var type = _a.type;
    return function (payload) { return ({
        type: type,
        payload: __assign(__assign({}, payload), { method: 'getBets' }),
        meta: { isApiCall: true },
    }); };
};
exports.makeGetBets = makeGetBets;
var getMatchBySlug = function (variables) { return ({
    type: constants_2.GET_MATCH_BY_SLUG_REQUEST,
    payload: {
        method: 'getMatchBySlug',
        variables: variables,
    },
    meta: {
        isApiCall: true,
    },
}); };
exports.getMatchBySlug = getMatchBySlug;
var getTournamentBySlug = function (variables) { return ({
    type: constants_2.GET_TOURNAMENT_BY_SLUG_REQUEST,
    payload: {
        method: 'getTournamentBySlug',
        variables: variables,
    },
    meta: {
        isApiCall: true,
    },
}); };
exports.getTournamentBySlug = getTournamentBySlug;
exports.getMatch = makeGetMatch({ type: constants_2.GET_MATCH_REQUEST });
exports.refetchMatch = makeGetMatch({ type: constants_2.REFETCH_MATCH_REQUEST });
var makeGetMissingMatches = function (_a) {
    var type = _a.type, withMarketsCount = _a.withMarketsCount;
    return function (variables, args) {
        return {
            type: type,
            payload: {
                method: 'getMatchesByIds',
                variables: __assign(__assign({}, variables), { withMarketsCount: withMarketsCount }),
                args: __assign({ missingMatchIds: variables.sportEventsIds }, (args || {})),
            },
            meta: { isApiCall: true },
        };
    };
};
exports.makeGetMissingMatches = makeGetMissingMatches;
var makeGetMatchesByEventIds = function (_a) {
    var type = _a.type, withMarketsCount = _a.withMarketsCount, meta = _a.meta;
    return function (variables, args) {
        return {
            type: type,
            payload: {
                method: 'getMatchesByEventIds',
                variables: __assign(__assign({}, variables), { withMarketsCount: withMarketsCount }),
                args: args,
            },
            meta: __assign({ isApiCall: true }, meta),
        };
    };
};
exports.makeGetMatchesByEventIds = makeGetMatchesByEventIds;
function makeGetMatchesByFilters(_a) {
    var type = _a.type, withListType = _a.withListType, withRequestId = _a.withRequestId, meta = _a.meta;
    return function (inputVars, args) {
        var variables = inputVars;
        var defaultArgs = {
            isTopMarkets: !!variables.isTopMarkets,
        };
        if (withListType) {
            defaultArgs.listType = utils_1.getRouteFromHistory();
        }
        if (withRequestId) {
            defaultArgs.requestId = Date.now();
        }
        if (!variables.marketStatusesForSportEvent) {
            variables.marketStatusesForSportEvent = variables.marketStatuses;
        }
        return {
            type: type,
            payload: {
                method: 'getMatchesByFilters',
                variables: variables,
                args: __assign(__assign({}, defaultArgs), args),
            },
            meta: __assign({ isApiCall: true }, meta),
        };
    };
}
exports.makeGetMatchesByFilters = makeGetMatchesByFilters;
function makeSearchMatchesFn(type) {
    var getMatches = makeGetMatchesByFilters({
        type: type,
        withListType: true,
        withRequestId: true,
        meta: {
            group: constants_2.GROUP_GET_MATCHES_REQUEST,
        },
    });
    return function (variables, args) {
        if (variables === void 0) { variables = undefined; }
        if (args === void 0) { args = { withLoader: true }; }
        var resultVariables = variables
            ? __assign(__assign(__assign({}, constants_1.paginationVariables), variables), utils_1.getAppliedFilters()) : utils_1.getDefaultVariables();
        return getMatches(resultVariables, args);
    };
}
exports.makeSearchMatchesFn = makeSearchMatchesFn;
var deleteMatchId = function (variables) { return ({
    type: constants_2.DELETE_MATCH_ID,
    payload: variables,
}); };
exports.deleteMatchId = deleteMatchId;
var endMatch = function (variables) { return ({
    type: constants_2.MATCH_ENDED,
    payload: variables,
}); };
exports.endMatch = endMatch;
var getFreebets = function () { return ({
    type: constants_2.GET_FREE_BETS_REQUEST,
    payload: {
        method: 'getFreeBets',
        variables: {},
        args: {},
    },
    meta: {
        isApiCall: true,
    },
}); };
exports.getFreebets = getFreebets;
var getMarketTemplates = function (variables) { return ({
    type: constants_2.GET_MARKET_TEMPLATES_REQUEST,
    payload: {
        method: 'getMarketTemplates',
        variables: variables,
    },
    meta: {
        isApiCall: true,
    },
}); };
exports.getMarketTemplates = getMarketTemplates;
var getEventMatchOfTheDay = function (variables, args) {
    return {
        type: constants_2.GET_EVENT_MATCH_OF_THE_DAY_REQUEST,
        payload: {
            method: 'getEventMatchOfTheDay',
            variables: variables,
            args: args,
        },
        meta: {
            isApiCall: true,
        },
    };
};
exports.getEventMatchOfTheDay = getEventMatchOfTheDay;
var getEventLiveOfTheDay = function (variables, args) {
    return {
        type: constants_2.GET_EVENT_LIVE_OF_THE_DAY_REQUEST,
        payload: {
            method: 'getEventLiveOfTheDay',
            variables: variables,
            args: args,
        },
        meta: {
            isApiCall: true,
        },
    };
};
exports.getEventLiveOfTheDay = getEventLiveOfTheDay;
var getOddsStatistic = function (sportEventIds) { return ({
    type: constants_2.GET_BETS_BIDDING_REQUEST,
    payload: {
        method: 'getOddsStatistic',
        variables: { sportEventIds: sportEventIds },
    },
    meta: {
        isApiCall: true,
    },
}); };
exports.getOddsStatistic = getOddsStatistic;
var storeNormalizedEntities = function (payload, meta) { return ({
    type: constants_2.STORE_NORMALIZED_ENTITIES,
    payload: payload,
    meta: meta,
}); };
exports.storeNormalizedEntities = storeNormalizedEntities;
var deleteEntities = function (payload) {
    return utils_1.makeAction(constants_2.DELETE_ENTITIES, payload);
};
exports.deleteEntities = deleteEntities;
//# sourceMappingURL=actions.js.map